import { io, Socket } from "socket.io-client";
import { parse } from "cookie";
import parser from "socket.io-msgpack-parser";
import { SOCKET_LINK, socketOptions } from "src/config/constants";
import { authHeader } from "src/utils/authHeader";

let socket: Socket;

const connect = (onConnect: (arg0: boolean) => void) => {
  socket = io(`${SOCKET_LINK}/v1/fancyMarket`, {
    // forceNew: true,
    // withCredentials: true,
    // extraHeaders: {
    //     Authorization: authHeader(),
    // }
    parser,
    ...socketOptions,
    query: {
      authorization: authHeader(),
    },
  });

  const COOKIE_NAME = process.env.REACT_APP_SECRET_KEY || "betfair";

  socket.io.on("open", () => {
    console.info("🚀 ~ fancy socket ~ open:");
    const transport: any = socket.io.engine.transport;
    transport.on("pollComplete", () => {
      const request = transport.pollXhr.xhr;
      const cookieHeader = request?.getResponseHeader("set-cookie");
      if (!cookieHeader) {
        return;
      }
      cookieHeader.forEach((cookieString: string) => {
        if (cookieString.includes(`${COOKIE_NAME}=`)) {
          const cookie = parse(cookieString);
          socket.io.opts.extraHeaders = {
            cookie: `${COOKIE_NAME}=${cookie[COOKIE_NAME]}`,
          };
        }
      });
    });
  });

  return new Promise((res, rej) => {
    socket?.on("connect", () => {
      console.info("fancy socket ~ connect:");
      onConnect(true);
      res(socket);
    });
    socket?.once("connect_error", (err) => {
      console.info("fancy socket ~ connect_error:", err);
      rej(new Error("connect_error"));
    });
    socket?.once("connect_timeout", function (err) {
      console.info("fancy socket ~ connect_timeout:", err);
      rej(new Error("connect_timeout"));
    });

    socket.io.on("reconnect_attempt", (attempt) => {
      console.info("🔁 fancy socket ~ reconnect_attempt:", attempt);

      // refresh token each attempt (token may have changed)
      const token = authHeader();
      socket.io.opts.query = {
        ...(socket.io.opts.query as Record<string, any>),
        authorization: token,
      };
    });

    socket.io.on("reconnect", (attempt) => {
      console.info("✅ fancy socket ~ reconnected after attempts:", attempt);
      onConnect(true);
    });

    socket.io.on("reconnect_error", (err) => {
      console.info("❌ fancy socket ~ reconnect_error:", err);
    });

    socket.io.on("reconnect_failed", () => {
      console.info("🧨 fancy socket ~ reconnect_failed (gave up)");
      onConnect(false);
    });

    socket?.on("disconnect", function (reason) {
      console.info("fancy socket ~ disconnect:", reason);
      onConnect(false);
    });
  });
};

const joinRoom = (data: any) => {
  socket?.emit("join-fancy-market-room", JSON.stringify(data));
};

const roomJoined = (setData: (arg0: any) => void) => {
  socket?.on("room-joined", (data) => {
    setData(data);
  });
};

const leaveRoom = (data: any) => {
  socket?.emit("fancy-market-leave", JSON.stringify(data));
};
const disconnect = (userIds: any) => {
  // socket?.disconnect()
  const data = {
    leave_userIds: userIds,
  };
  socket?.emit("leave-room", data);
};

const disconnect2 = () => {
  socket?.disconnect();
};

const listenEvent = (eventName: any, setData: (arg0: any) => void) => {
  socket?.on(eventName, (data: any) => {
    setData(data);
  });
};

const chekUserConnected = (connectToRooms = () => {}) => {
  socket?.on("token-verified", (data) => {
    // console.log("IN users-connected - sport", data);
    if (data.data.isVerified) {
      connectToRooms();
    } else {
      // console.log('Its me')

      sessionStorage.clear();

      window.location.replace("/");
    }
  });
};

const socketError = () => {
  socket?.on("error", (data) => {
    console.log("Socket Error", { data });
  });
};

const fancySocketServices = {
  connect,
  joinRoom,
  listenEvent,
  disconnect,
  disconnect2,
  leaveRoom,
  roomJoined,
  socketError,
  chekUserConnected,
};

export default fancySocketServices;
